export const CHECKOUT_URL = 'https://adiospiojos.impultienda.ar/checkout'

/** Precio final de la oferta de lanzamiento. */
export const PRECIO_HOY = '$19.990'

/** Suma del valor de los 6 tomos + los 5 bonos. */
export const VALOR_TOTAL = '$244.400'
